export const APP_VERSION = "0.5.10";
export const MIN_PLAYERS = 5;
export const MAX_PLAYERS = 10;
export const LIBERAL_POLICY_GOAL = 5;
export const FASCIST_POLICY_GOAL = 6;
export const LIBERAL_POLICY_DECK_SIZE = 6;
export const FASCIST_POLICY_DECK_SIZE = 11;
export const ELECTION_TRACKER_LIMIT = 3;
export function resumeSecondsRemaining(resumeAt, now = Date.now()) {
    return Math.max(1, Math.ceil((resumeAt - now) / 1_000));
}
//# sourceMappingURL=index.js.map